import { render, staticRenderFns } from "./jifen_list.vue?vue&type=template&id=cf51f3fc&scoped=true&"
import script from "./jifen_list.vue?vue&type=script&lang=js&"
export * from "./jifen_list.vue?vue&type=script&lang=js&"
import style0 from "./jifen_list.vue?vue&type=style&index=0&id=cf51f3fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf51f3fc",
  null
  
)

export default component.exports